import { Alert, Button, Col, OverlayTrigger,  Row } from "react-bootstrap";
import React, { useEffect, useMemo, useRef, useState } from "react";
import Menubar from "../Menubar";
import { store } from "../../App";
import * as Yup from "yup";
import KpiService from "../../Services/KpiService";
import { AiOutlineSearch } from "react-icons/ai";
import { IoSendOutline } from "react-icons/io5";
import { GrDocumentPdf } from "react-icons/gr";
import { useFormik } from "formik";
import useAlert from "../Alert/useAlert";
import AlertModal from "../Alert/AlertModal";
import { FaAward, FaChartBar, FaFlag, FaMedal, FaStar } from "react-icons/fa";
import "./CriteriaPerformances.css";
import { FiArrowRight, FiPlusSquare } from "react-icons/fi";
import "../../Components/Report.css";
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, LabelList, ResponsiveContainer, Cell, } from "recharts";

const CriteriaPerformance = () => {
    const { showAlert, alertData, showAlertMessage, closeAlert } = useAlert();

    const reportStyles = {
        page: { padding: "3px 0px", fontFamily: "Arial, Helvetica, sans-serif", background: "#fff" },
        headerRow: { display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 12 },
        scoreBox: {
            width: 110,
            height: 110,
            borderRadius: 18,
            background: "#052a5a",
            color: "#fff",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: 42,
            fontWeight: 800,
        },
        grades: { display: "flex", gap: 14, flex: 1, justifyContent: "center", alignItems: "stretch" },
        gradeColumn: { display: "flex", flexDirection: "column", width: 320, borderRadius: 4, overflow: "hidden" },
        gradeHeader: (bg) => ({ background: bg, padding: "10px 6px", textAlign: "center", fontWeight: 800 }),
        gradeMiddle: { padding: "10px 6px", textAlign: "center", fontSize: 26, fontWeight: 800 },
        gradeBottom: { padding: "10px 6px", textAlign: "center", fontWeight: 800 },
        rightBox: {
            width: 110,
            height: 110,
            borderRadius: 18,
            background: "#052a5a",
            color: "#fff",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: 36,
            fontWeight: 800,
        },
        table: { width: "100%", borderCollapse: "collapse", marginTop: 12 },
        th: { border: "1px solid", padding: 8, fontWeight: 800, textAlign: "left" },
        td: { border: "1px solid #efc9b9", padding: 8, verticalAlign: "top" },
        sectionLabel: { width: 72, display: "flex", alignItems: "stretch", justifyContent: "center", marginRight: 12 },
        sectionLabelText: {
            width: 44,
            height: "100%",
            minHeight: "100%",
            alignSelf: "stretch",
            background: "#f8e1d8",
            padding: "6px 8px",
            borderRadius: 12,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
        },
        sectionLabelInner: {
            display: "inline-block",
            transform: "rotate(-90deg)",
            transformOrigin: "center",
            fontWeight: 800,
            whiteSpace: "nowrap",
        },
    };
    const modernStyles = {
        page: { padding: 20, background: "#F5F7FA" },
        heroCard: {
            background: "#fff",
            borderRadius: 16,
            padding: 20,
            textAlign: "center",
            boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
            marginBottom: 20,
        },
        kpiContainer: { display: "flex", gap: 16, marginBottom: 20 },
        kpiCard: (bg) => ({
            flex: 1,
            background: bg,
            borderRadius: 12,
            padding: 16,
            textAlign: "center",
            boxShadow: "0 2px 10px rgba(0,0,0,0.05)",
        }),
        sectionCard: {
            background: "#fff",
            borderRadius: 12,
            padding: "0px 0px",
            boxShadow: "0 2px 10px rgba(0,0,0,0.05)",
        },
        table: { width: "100%", borderCollapse: "collapse" },
        th: { color: "#000", padding: "8px", textAlign: "center", whiteSpace: "normal", wordBreak: "break-word" },
        td: {
            padding: "px",
            fontSize: "13px",
            fontWeight: "600",
            verticalAlign: "middle",
            whiteSpace: "normal",
            wordBreak: "break-word",
            overflowWrap: "anywhere",
        },
        badge: (item) => ({
            padding: "4px 10px",
            borderRadius: 10,
            fontWeight: "bold",
            background: item.color_code || "",
            color: "#000",
        }),
    };

    const reportRef = useRef(null);
    const [remarks, setRemarks] = useState("");
    const [status, setStatus] = useState("");
    const [scoresData, setScoresData] = useState([]);
    const [criteriaData, setCriteriaData] = useState([]);
    const [indicatorData, setIndicatorData] = useState([]);

    const [searchIndicatorData, setSearchIndicatorData] = useState("");

    const [generatedTime, setGeneratedTime] = useState("");
    const [statusCode, setStatusCode] = useState("");
    const [barData, setBarData] = useState([]);
    const [descTime, setDescTime] = useState("");
    const [uploadedFileId, setUploadedFileId] = useState("");

    const [forwardedDateTime, setForwardedDateTime] = useState("");
    const [approvedDateTime, setApprovedDateTime] = useState("");
    


    useEffect(() => {
        setGeneratedTime(getCurrentDateTime());
    }, []);
    let username = localStorage.getItem("username");
    let role = localStorage.getItem("role");
    let districtid = localStorage.getItem("districtid");
    let mandalid = localStorage.getItem("mandalid");
    let assemblyid = localStorage.getItem("assemblyid");
    const [monthOptions, setMonthOptions] = useState([]);

    const isInitial = useRef(true);
    const validationSchema = Yup.object({});
    const formik = useFormik({
        initialValues: {
            category: "month",
            year: "2026-27",
            month: "",
            Mandal: "",
            district_id: "",
            criteriaRemarks: "",
        },
        validationSchema: validationSchema,
        onSubmit: async (values) => {
            await fetchData();
        },
    });

    useEffect(() => {
        if (isInitial.current) {
            isInitial.current = false;
            return;
        }
        formik.setValues({ ...formik.values, year: "", month: "" });
    }, [formik.values.category]);

    const scoreForMonth = formik.values.category === "month"
        ? formik.values.month || "0" : formik.values.category === "provisional" || formik.values.category === "annual" ? "3" : "0";
    const scoreCatId = formik.values.category === "month" ? "Monthly" : formik.values.category === "provisional"
        ? "Provisionally" : formik.values.category === "annual" ? "Annually" : "Monthly";
    const categoryOptions = [{ value: "month", label: "Month" }, { value: "provisional", label: "Provisional" }, { value: "annual", label: "Annual" },];

    const getMaxYear = () => {
        const years = ["2026-27", "2025-26"];

        return years
            .filter(Boolean)
            .sort((a, b) => {
                const yearA = Number(a.split("-")[0]);
                const yearB = Number(b.split("-")[0]);
                return yearB - yearA;
            })[0] || "";
    };

    const fetchMonths = async () => {
        try {
            const params = { userId: username, year: formik.values.year, type: "CRITERISDASHBOARD" };
            const response = await KpiService.monthNameFromMonthCode(params);
            if (response?.data?.SCODE === "01" && response.data.dataList) {
                const months = response.data.dataList.map((month) => ({
                    value: month.month_code, label: month.month_name,
                }));
                setMonthOptions(months);
                const maxMonth = months.length
                    ? [...months].sort(
                        (a, b) => Number(b.value) - Number(a.value)
                    )[0]?.value?.toString() || ""
                    : "";

                formik.setFieldValue("month", maxMonth);
            } else if (response?.data?.SCODE === "02") {
                showAlertMessage(response.data?.SDESC, "warning");
                setMonthOptions([]);
                setScoresData([]);
                setCriteriaData([]);
                setIndicatorData([]);
                setRemarks("");
                setStatus("");
            } else {
                setMonthOptions([]);
                setScoresData([]);
                setCriteriaData([]);
                setIndicatorData([]);
                setRemarks("");
                setStatus("");
            }
        } catch (error) {
            console.error("Error fetching months:", error);
            setMonthOptions([]);
        }
    };
    useEffect(() => {
        if (formik.values.year) {
            fetchMonths();
        } else {
            setMonthOptions([]);
            formik.setFieldValue("month", "");
        }
    }, [formik.values.year]);

    useEffect(() => {
        if (monthOptions.length > 0) {
            const maxMonth = [...monthOptions].sort((a, b) => Number(b.value) - Number(a.value))[0]?.value;
            if (!formik.values.month) { formik.setFieldValue("month", maxMonth); }
            setRemarks("");
        }
    }, [monthOptions]);

    useEffect(() => {
        if (formik.values.year && formik.values.month) {
            setRemarks("");
            fetchData();
        }
    }, [formik.values.month]);

    const fetchData = async () => {
        setSearchIndicatorData("");
        const params = {
            userId: username,
            scoreForMonth,
            scoreCatId,
            year: formik.values.year,
            // districtId: (role === "65" || role === "73") ? "0" : districtid,
            type: role === "2" || role === "64" ? "dist" : role === "65" || role === "73" ? "const" : "mandal",
            // mandalId: (role === "2" || role === "64" || role === "65" || role === "73") ? "0" : mandalid,
            accode: role === "65" || role === "73" ? assemblyid : "0",
        };
        if (role !== "65" && role !== "73") {
            params.mandalId = role === "2" || role === "64" || role === "65" || role === "73" ? "0" : mandalid;
            params.districtId = role === "65" || role === "73" ? "0" : districtid;
        }
        const barparams = {
            userId: username,
            year: formik.values.year,
            scoreCatId,
            scoreForMonth,
            districtId: role === "2" || role === "64" ? "0" : districtid,
            type: role === "2" || role === "64" ? "dist" : role === "65" || role === "73" ? "const" : "mandal",
        };

        const descparams = { "userId": username, "year": formik.values.year, scoreCatId, scoreForMonth, "dashboardType": "CRITERISDASHBOARD" }


        try {
            store.dispatch({ type: "SHOW_SPINNER" });
            const res = await KpiService.criteriaPerformanceDashboardScoreCard(params);
            // const barres = await KpiService.criteriaPerformanceDashboardGraphScoreCard(barparams);


            let barres = null;

            if (role !== "65" && role !== "73") {
                barres = await KpiService.criteriaPerformanceDashboardGraphScoreCard(barparams);
            }
            const descres = await KpiService.dashboardDisplaysDateWise(descparams);

            if (!res?.data) return;


            if (barres?.data?.SCODE === "01") {
                const dataList = barres.data.scoreData || [];

                const isDistrictRole = role === "2" || role === "64";

                const finalData = dataList
                    .filter((item) => {
                        if (isDistrictRole) {
                            return (
                                item.district_id != null &&
                                item.district_name != null &&
                                String(item.district_name).trim() !== ""
                            );
                        }

                        return (
                            item.mandal_id != null &&
                            item.mandal_name != null &&
                            String(item.mandal_name).trim() !== ""
                        );
                    })
                    .map((item) => ({
                        // District data
                        district_id: item.district_id,
                        district_code: item.district_code,
                        district_name: item.district_name,

                        // Mandal data
                        mandal_id: item.mandal_id,
                        mandal_name: item.mandal_name,

                        // Score
                        average_score: Number(item.averagescore) || 0,

                        grade: item.grade,
                        color_code: item.color_code,
                        noofindicators: item.noofindicators,
                    })).sort((a, b) => b.average_score - a.average_score);


                setBarData(finalData);
            }
            else { setBarData([]); }


            if (descres?.data?.SCODE === "01") {
                setDescTime(descres?.data?.dataList[0]?.insert_time);
            } else {
                setDescTime("")
            }
            const scode = String(res.data.SCODE || "");
            setStatusCode(scode);
            if (scode !== "01") {
                showAlertMessage(res.data?.SDESC, "warning");
                setScoresData([]);
                setCriteriaData([]);
                setIndicatorData([]);
                setRemarks("");
                setStatus("");
                return;
            }
            setScoresData(res.data.scoreData || []);
            setCriteriaData(res.data.criteriaData || []);
            setIndicatorData(res.data.indicatorData || []);
            const remarkArr = res.data?.remarkData || [];
            let apiRemarks = "";
            let apiStatus = "";
            if (Array.isArray(remarkArr) && remarkArr.length > 0) {
                const normalized = remarkArr.map((r) => ({
                    status: String(r?.status || "")
                        .trim()
                        .toUpperCase(),
                    remarks: r?.remarks || "",
                    //  insert_time:r?.entered_on || r?.insert_time || r?.created_time || r?.date_time || "",
                }));

                const approvedEntry = normalized.find((r) => r.status === "APPROVED");
                const forwardedEntry = normalized.find((r) => r.status === "FORWARDED");

                setForwardedDateTime( forwardedEntry?.insert_time || "" ); 
                 setApprovedDateTime( approvedEntry?.insert_time || "" );

                if (approvedEntry) {
                    apiStatus = "APPROVED";
                    apiRemarks = approvedEntry.remarks;
                } else if (forwardedEntry) {
                    apiStatus = "FORWARDED";
                    apiRemarks = forwardedEntry.remarks;
                } else {
                    apiStatus = normalized[0]?.status || "";
                    apiRemarks = normalized[0]?.remarks || "";
                }
            }
             else { setForwardedDateTime(""); setApprovedDateTime(""); }

            setRemarks(apiRemarks);
            setStatus(apiStatus);
        } catch (error) {
            console.error(error);

            setScoresData([]);
            setCriteriaData([]);
            setIndicatorData([]);
            setRemarks("");
            setStatus("");
            setBarData([]);
        } finally {
            store.dispatch({ type: "HIDE_SPINNER" });
        }
    };

    const getSectorData = (type) =>
        (criteriaData || []).find((item) => item?.cs_indicator_type?.toLowerCase() === type) || {};

    const economicData = getSectorData("economic");
    const socialData = getSectorData("social");
    const governanceData = getSectorData("governance");
    const [isDownloading, setIsDownloading] = useState(false);
    const [isPrinting, setIsPrinting] = useState(false);

    const filteredindicatorData = useMemo(() => {
        const search = searchIndicatorData.trim().toLowerCase();

        return (indicatorData || []).filter((item) => {
            return (
                item.cs_indicator_name?.toLowerCase().includes(search) ||
                item.periodic_name?.toLowerCase().includes(search) ||
                String(item.achivementvalue || "")
                    .toLowerCase()
                    .includes(search) ||
                String(item.cumulative_achievement_percent || "")
                    .toLowerCase()
                    .includes(search) ||
                String(item.previous_period_percent || "")
                    .toLowerCase()
                    .includes(search) ||
                String(item.averagescore || "")
                    .toLowerCase()
                    .includes(search) ||
                item.grade?.toLowerCase().includes(search)
            );
        });
    }, [indicatorData, searchIndicatorData]);
    const economicTable = useMemo(() => {
        return filteredindicatorData.filter((item) => item.cs_indicator_type === "Economic");
    }, [filteredindicatorData]);

    const socialTable = useMemo(() => {
        return filteredindicatorData.filter((item) => item.cs_indicator_type === "Social");
    }, [filteredindicatorData]);

    const governanceTable = useMemo(() => {
        return filteredindicatorData.filter((item) => item.cs_indicator_type === "Governance");
    }, [filteredindicatorData]);

    const prepareScoreRingsForPdf = (cloned) => {
        const rings = cloned.querySelectorAll(".score-ring");

        rings.forEach((svg) => {
            const circles = svg.querySelectorAll("circle");

            if (circles.length < 2) return;

            // Get score from SVG text
            const text = svg.querySelector("text");
            const value = Number(text?.textContent?.trim()) || 0;

            // Get color from the colored SVG circle
            const color = circles[1]?.getAttribute("stroke") || "#3DD9FF";

            const clampedValue = Math.max(0, Math.min(100, value));

            const outerSize = 96;
            const ringWidth = 9;
            const innerSize = outerSize - ringWidth * 2;

            const ring = document.createElement("div");

            ring.style.width = `${outerSize}px`;
            ring.style.height = `${outerSize}px`;
            ring.style.borderRadius = "50%";
            ring.style.background = `
            conic-gradient(
                from 0deg,
                ${color} 0deg ${clampedValue * 3.6}deg,
                #e9edf1 ${clampedValue * 3.6}deg 360deg
            )
        `;

            ring.style.display = "flex";
            ring.style.alignItems = "center";
            ring.style.justifyContent = "center";
            ring.style.flexShrink = "0";

            // Inner white circle
            const inner = document.createElement("div");

            inner.style.width = `${innerSize}px`;
            inner.style.height = `${innerSize}px`;
            inner.style.borderRadius = "50%";
            inner.style.background = "#fff";
            inner.style.display = "flex";
            inner.style.alignItems = "center";
            inner.style.justifyContent = "center";

            inner.style.fontFamily = "Arial, Helvetica, sans-serif";

            inner.style.fontSize = "32px";
            inner.style.fontWeight = "800";
            inner.style.color = color;

            inner.textContent = clampedValue;

            ring.appendChild(inner);

            svg.parentNode.replaceChild(ring, svg);
        });
    };


    const handlePrint = async () => {
    // 1. Check whether approved file path exists
    const filePath = scoresData?.[0]?.filePath;
     console.log("hai")
    if (status === "APPROVED" && filePath) {
        // 2. Print the already uploaded PDF
        const printWindow = window.open(filePath, "_blank");
        console.log("hey")

        if (printWindow) {
            printWindow.onload = () => {
                printWindow.focus();
                printWindow.print();
            };
        }

        return;
    }

    // 3. Otherwise execute your existing print functionality
    handleDownloadReport();
};

    const handleDownloadReport = () => {
        const input = reportRef.current;
        if (!input) return;

        setIsDownloading(true);

        try {
            // ==========================
            // Clone Report
            // ==========================
            const cloned = input.cloneNode(true);
            prepareScoreRingsForPdf(cloned);


            // ==========================
            // Replace Textareas
            // ==========================
            cloned.querySelectorAll("textarea").forEach((textarea) => {
                const div = document.createElement("div");

                div.innerText = textarea.value || "";
                div.style.whiteSpace = "pre-wrap";
                div.style.fontSize = "16px";
                div.style.lineHeight = "1.5";
                div.style.padding = "10px";
                div.style.border = "2px solid #999";
                div.style.wordWrap = "break-word";
                div.style.overflowWrap = "break-word";
                div.style.wordBreak = "break-word";
                div.style.minHeight = textarea.offsetHeight + "px";

                textarea.parentNode.replaceChild(div, textarea);
            });

            // ==========================
            // Signature
            // ==========================
            if ((role === "64") && status === "APPROVED") {
                const sigDiv = document.createElement("div");

                sigDiv.style.marginTop = "30px";
                sigDiv.style.textAlign = "right";
                sigDiv.style.pageBreakInside = "avoid";

                sigDiv.innerHTML = `
        <div style="font-weight:bold;">
            Signed By
        </div>

        <div style="margin-top:5px;">
            ${role === "71" ? `MPDO ${scoreObj.mandal_name || ""}` : `COLLECTOR ${scoreObj.district_name || ""}`}
        </div>

        <div style="margin-top:5px;font-size:12px;">
            ${getCurrentDateTime()}
        </div>
      `;

                cloned.appendChild(sigDiv);
            }



// ==========================
// Approval / Validation Signatures based on conditions newly added
// ==========================

// const districtName = scoreObj?.district_name || "";
// const mandalName = scoreObj?.mandal_name || "";
// const constituencyName = scoreObj?.acname || scoreObj?.assembly_name || scoreObj?.constituency_name || "";
    

// const signatureContainer = document.createElement("div");

// signatureContainer.style.width = "100%";
// signatureContainer.style.display = "flex";
// signatureContainer.style.justifyContent = "space-between";
// signatureContainer.style.alignItems = "flex-start";
// signatureContainer.style.marginTop = "35px";
// signatureContainer.style.padding = "0 20px";
// signatureContainer.style.boxSizing = "border-box";
// signatureContainer.style.pageBreakInside = "avoid";
// signatureContainer.style.breakInside = "avoid";


// // ------------------------------------
// // LEFT : CPO VALIDATION
// // ------------------------------------

// if (role === "2"  && (status === "FORWARDED" || status === "APPROVED")) {

//     const validatedDiv = document.createElement("div");

//     validatedDiv.style.width = "45%";
//     validatedDiv.style.textAlign = "left";
//     validatedDiv.style.fontFamily = "Arial, Helvetica, sans-serif";
//     validatedDiv.style.fontSize = "14px";
//     validatedDiv.style.lineHeight = "1.6";

//     validatedDiv.innerHTML = `
//         <div style="
//             font-weight:700;
//             font-size:15px;
//             margin-bottom:4px;
//         ">
//             Validated by: Chief Planning Officer (CPO)
//         </div>

//         <div>
//             District: ${districtName}
//         </div>

//         <div>
//             Date &amp; Time:
//             ${forwardedDateTime || "-"}
//         </div>
//     `;

//     signatureContainer.appendChild(validatedDiv);
// }
// if (role === "3" && (status === "FORWARDED" || status === "APPROVED") ) {

//     const validatedDiv = document.createElement("div");

//     validatedDiv.style.width = "45%";
//     validatedDiv.style.textAlign = "left";
//     validatedDiv.style.fontFamily = "Arial, Helvetica, sans-serif";
//     validatedDiv.style.fontSize = "14px";
//     validatedDiv.style.lineHeight = "1.6";

//     validatedDiv.innerHTML = `
//         <div style="
//             font-weight:700;
//             font-size:15px;
//             margin-bottom:4px;
//         ">
//             Validated by: Assistant Statistical Officer (ASO)
//         </div>

//         <div>
//             Mandal: ${scoreObj?.mandal_name || "-"}
//         </div>

//         <div>
//             Date &amp; Time: ${forwardedDateTime || getCurrentDateTime()}
//         </div>
//     `;

//     signatureContainer.appendChild(validatedDiv);
// }

// if (role === "73" && status === "APPROVED") {

//     const approvedDiv = document.createElement("div");

//     approvedDiv.style.width = "45%";
//     approvedDiv.style.textAlign = "left";
//     approvedDiv.style.fontFamily = "Arial, Helvetica, sans-serif";
//     approvedDiv.style.fontSize = "14px";
//     approvedDiv.style.lineHeight = "1.6";

//     approvedDiv.innerHTML = `
//         <div style="
//             font-weight:700;
//             font-size:15px;
//             margin-bottom:4px;
//         ">
//             Approved by: Constituency Special Officer
//         </div>

//         <div>
//             Constituency: ${constituencyName || "-"}
//         </div>

//         <div>
//             Date &amp; Time: ${approvedDateTime || "-"}
//         </div>
//     `;

//     signatureContainer.appendChild(approvedDiv);
// }


// // ------------------------------------
// // RIGHT : DISTRICT COLLECTOR APPROVAL
// // ------------------------------------

// if ((role === "64" || role === "2") && status === "APPROVED") {

//     const approvedDiv = document.createElement("div");

//     approvedDiv.style.width = "45%";
//     approvedDiv.style.textAlign = "right";
//     approvedDiv.style.fontFamily = "Arial, Helvetica, sans-serif";
//     approvedDiv.style.fontSize = "14px";
//     approvedDiv.style.lineHeight = "1.6";

//     approvedDiv.innerHTML = `
//         <div style="
//             font-weight:700;
//             font-size:15px;
//             margin-bottom:4px;
//         ">
//             Approved by: District Collector
//         </div>

//         <div>
//             District: ${districtName}
//         </div>

//         <div>
//             Date &amp; Time:
//             ${approvedDateTime || "-"}
//         </div>
//     `;

//     signatureContainer.appendChild(approvedDiv);
// }
// // ------------------------------------
// // RIGHT : CONSTITUENCY APPROVAL
// // ------------------------------------



// if (signatureContainer.children.length > 0) {
//     cloned.appendChild(signatureContainer);
// }

            // ==========================
            // Copy CSS
            // ==========================
            const styles = Array.from(document.querySelectorAll('link[rel="stylesheet"], style'))
                .map((style) => style.outerHTML)
                .join("");

            // ==========================
            // Print using hidden iframe
            // ==========================

            const iframe = document.createElement("iframe");

            iframe.style.position = "fixed";
            iframe.style.right = "0";
            iframe.style.bottom = "0";
            iframe.style.width = "0";
            iframe.style.height = "0";
            iframe.style.border = "0";

            document.body.appendChild(iframe);

            const printDoc = iframe.contentDocument || iframe.contentWindow.document;

            printDoc.open();

            printDoc.write(`
<!DOCTYPE html>
<html>
<head>
<meta charset="UTF-8" />


${styles}
<style>

@page{
    size:tabloid landscape;
    margin:5mm;
}

html,
body{
    margin:0;
    padding:0;
    background:#fff;
    overflow:visible !important;
    -webkit-print-color-adjust:exact !important;
    print-color-adjust:exact !important;
}

body{
    zoom:85%;
}

table{
    width:100%;
    border-collapse:collapse;
}

thead{
    display:table-header-group;
}

tfoot{
    display:table-footer-group;
}

tr,
td,
th{
    page-break-inside:avoid;
    break-inside:avoid;
}

img,
svg{
    max-width:100%;
    height:auto;
}



</style>

</head>

<body>

<div id="report-container">

${cloned.innerHTML}

</div>

</body>

</html>
`);

            printDoc.close();

            iframe.onload = () => {


                setIsDownloading(false);

                setTimeout(() => {
                    iframe.contentWindow.focus();

                    iframe.contentWindow.print();

                    iframe.contentWindow.onafterprint = () => {
                        document.body.removeChild(iframe);
                    };
                }, 800);
            };
        } catch (error) {
            console.error("Print Error:", error);

            setIsDownloading(false);
        }
    };

    const validateRemarks = () => {
        if (!remarks || remarks.trim() === "") {
            showAlertMessage("Remarks should not be empty.", "warning");
            return false;
        }

        if (remarks.length >= 1000) {
            showAlertMessage("Maximum 1000 characters allowed.", "warning");
            return false;
        }

        return true;
    };

    const SaveandForward = async () => {
        if (!validateRemarks()) return;

        setSearchIndicatorData("");

        const params = {
            userId: username,
            scoreForMonth,
            scoreCatId,
            year: formik.values.year,
            // type: role === "2" || role === "64" ? "dist" : "mandal",
            // districtId: districtid,
            // mandalId: role === "2" || role === "64" ? "0" : mandalid,

            // districtId: (role === "65" || role === "73") ? "0" : districtid,
            type: role === "2" || role === "64" ? "dist" : role === "65" || role === "73" ? "const" : "mandal",
            // mandalId: (role === "2" || role === "64" || role === "65" || role === "73") ? "0" : mandalid,
            accode: role === "65" || role === "73" ? assemblyid : "0",
            scoreForYear: formik.values.year,
            criteriaRemarks: remarks,
        };
        if (role !== "65" && role !== "73") {
            params.mandalId = role === "2" || role === "64" || role === "65" || role === "73" ? "0" : mandalid;
            params.districtId = role === "65" || role === "73" ? "0" : districtid;
        }

        try {
            store.dispatch({ type: "SHOW_SPINNER" });

            const res = await KpiService.criteriaPerformanceDashboardScoreCardForward(params);

            const scode = String(res.data.SCODE);
            const sdesc = res?.data?.SDESC || "No response from server";

            setStatusCode(scode);
            if (scode === "01") {
                await showAlertMessage(sdesc, "success");

                try {
                    await fetchData();
                } catch (e) {
                    console.error("fetchData error:", e);
                }
            } else if (scode === "02" || scode === "03") {
                showAlertMessage(sdesc, "warning");
            } else {
                showAlertMessage(sdesc, "error");
            }
        } catch (error) {
            console.error("API Error:", error);
            showAlertMessage("Failed to forward. Please try again.", "error");
        } finally {
            store.dispatch({ type: "HIDE_SPINNER" });
        }
    };
    const isRemarksEmpty = !remarks || remarks.trim() === "";
    const handleApprove = async () => {
        if ((role === "64" ) && isRemarksEmpty) {
            showAlertMessage("Not yet forwarded from previous level to Approve", "warning");
            return;
        }

        if (!validateRemarks()) return;

        setSearchIndicatorData("");

        try {
            store.dispatch({ type: "SHOW_SPINNER" });

            const html2pdf = (await import("html2pdf.js")).default;
            const input = reportRef.current;

            if (!input) {
                showAlertMessage("Report content not found", "error");
                return;
            }

            const cloned = input.cloneNode(true);

            const sectionCards = cloned.querySelectorAll(".sectionCard");

            const economicRows = sectionCards[0]?.querySelectorAll("tbody tr")?.length || 0;

            if (economicRows >= 9 && sectionCards[0]) {
                sectionCards[0].style.pageBreakAfter = "always";
                sectionCards[0].style.breakAfter = "always";
            }

            if (economicRows >= 5 && economicRows <= 8 && sectionCards[2]) {
                sectionCards[2].style.pageBreakBefore = "always";
                sectionCards[2].style.breakBefore = "always";
            }

            cloned.querySelectorAll("[style*='overflow']").forEach((el) => {
                el.style.height = "auto";
                el.style.overflow = "visible";
            });

            cloned.querySelectorAll("textarea").forEach((textarea) => {
                const div = document.createElement("div");
                div.innerText = textarea.value || "";
                div.style.whiteSpace = "pre-wrap";
                div.style.fontSize = "16px";
                div.style.padding = "10px";
                div.style.border = "2px solid #999";
                textarea.parentNode.replaceChild(div, textarea);
            });

            if ((role === "64" ) && status === "APPROVED") {
                const sigDiv = document.createElement("div");
                sigDiv.style.marginTop = "20px";
                sigDiv.style.textAlign = "right";
                sigDiv.innerHTML = `
                <div style="font-weight:bold;">Signed By</div>
                <div style="margin-top:5px;">
                    ${role === "71"
                        ? `MPDO ${scoreObj.mandal_name || ""}`
                        : `COLLECTOR ${scoreObj.district_name || ""}`
                    }
                </div>
                <div style="font-size:12px; margin-top:5px;">
                    ${getCurrentDateTime()}
                </div>
            `;
                cloned.appendChild(sigDiv);
            }

            const pdfOptions = {
                margin: [5, 5, 5, 5],
                image: { type: "jpeg", quality: 1 },
                html2canvas: { scale: 2, useCORS: true, scrollY: 0 },
                jsPDF: {
                    unit: "mm",
                    format: [350, 210],
                    orientation: "landscape",
                },
            };

            const worker = html2pdf().set(pdfOptions).from(cloned);
            const pdf = await worker.toPdf().get("pdf");

            const pdfBlob = pdf.output("blob");

            const fileName =
                role === "65" || role === "73"
                    ? `${scoreObj.acname || ""}_Constituency_Report.pdf`
                    : `${role === "2" || role === "64" ? scoreObj.district_name : scoreObj.mandal_name}_${role === "2" || role === "64" ? "District" : "Mandal"
                    }_${months[scoreObj.score_for_month - 1]}_Month_Report.pdf`;

            const sanitizeFileName = (name = "") => {
                let result = "";
                let prevUnderscore = false;

                for (const ch of name) {
                    const isAllowed =
                        (ch >= "a" && ch <= "z") ||
                        (ch >= "A" && ch <= "Z") ||
                        (ch >= "0" && ch <= "9") ||
                        ch === "." ||
                        ch === "_" ||
                        ch === "-";

                    if (isAllowed) {
                        result += ch;
                        prevUnderscore = false;
                    } else if (!prevUnderscore) {
                        result += "_";
                        prevUnderscore = true;
                    }
                }

                let start = 0;
                let end = result.length;

                while (start < end && result[start] === "_") {
                    start++;
                }

                while (end > start && result[end - 1] === "_") {
                    end--;
                }

                return result.slice(start, end);
            };

            const safeFileName = sanitizeFileName(fileName) || "report.pdf";

            const isValidFileName = /^[A-Za-z0-9._-]+$/.test(safeFileName);
            if (!isValidFileName) {
                showAlertMessage(
                    "Invalid filename. Only letters, numbers, dot, underscore and hyphen are allowed",
                    "warning"
                );
                return;
            }

            const formData = new FormData();
            formData.append("file", pdfBlob, safeFileName);

            const loginRes = await KpiService.getFilesUploadToken();

            console.log("LOGIN RESPONSE DATA:", loginRes?.data);

            const uploadToken = loginRes?.data;

            // const uploadToken = loginRes?.data?.[0]?.Access_token?.access_token;
            console.log("UPLOAD TOKEN:", uploadToken);

            const uploadRes = await KpiService.CriteriaperformanceUploadfiles(formData, uploadToken);
            const uploadData = uploadRes?.data;

            console.log("UPLOAD RESPONSE:", uploadData);

            const filePath = uploadData;

            const fileId = String(filePath).split("_")[0];

            console.log("FILE ID:", fileId);

            setUploadedFileId(fileId);

            if (!filePath) {
                showAlertMessage("File upload failed", "error");
                return;
            }

            const params = {
                userId: username,
                scoreForMonth,
                scoreCatId,
                year: formik.values.year,
                // type: role === "2" || role === "64" ? "dist" : "mandal",
                // districtId: districtid,
                // mandalId: role === "2" || role === "64" ? "0" : mandalid,

                // districtId: (role === "65" || role === "73") ? "0" : districtid,
                type: role === "2" || role === "64" ? "dist" : role === "65" || role === "73" ? "const" : "mandal",
                // mandalId: (role === "2" || role === "64" || role === "65" || role === "73") ? "0" : mandalid,
                accode: role === "65" || role === "73" ? assemblyid : "0",

                criteriaRemarks: remarks,
                fileName: fileName,
                filePath: filePath,
            };
            if (role !== "65" && role !== "73") {
                params.mandalId = role === "2" || role === "64" || role === "65" || role === "73" ? "0" : mandalid;
                params.districtId = role === "65" || role === "73" ? "0" : districtid;
            }

            const res = await KpiService.criteriaPerformanceDashboardScoreCardApprove(params);
            const scode = String(res?.data?.SCODE);
            const sdesc = res?.data?.SDESC || "No response from server";

            if (scode === "01") {
                await showAlertMessage(sdesc, "success");

                try {
                    await fetchData();
                } catch (e) {
                    console.error("fetchData error:", e);
                }
            } else if (scode === "03") {
                showAlertMessage(sdesc, "warning");
            } else if (scode === "02") {
                showAlertMessage(sdesc, "warning");
            } else {
                showAlertMessage(sdesc, "error");
            }
        } catch (err) {
            console.error(err);
            showAlertMessage("Something went wrong.", "error");
        } finally {
            store.dispatch({ type: "HIDE_SPINNER" });
        }
    };
    const selectedYear = formik?.values?.year || "";

    const isLocked =
        ((role === "64" ||  role === "73") && status === "APPROVED") ||
        ((role === "2" || role === "3" || role === "65") && (status === "APPROVED" || status === "FORWARDED"));

    const getCurrentDateTime = () => {
        const now = new Date();
        const day = String(now.getDate()).padStart(2, "0");
        const month = String(now.getMonth() + 1).padStart(2, "0");
        const year = String(now.getFullYear()).slice(-2);
        const hours = String(now.getHours()).padStart(2, "0");
        const minutes = String(now.getMinutes()).padStart(2, "0");
        const seconds = String(now.getSeconds()).padStart(2, "0");
        return `${day}/${month}/${year},${hours}:${minutes}:${seconds}`;
    };
    const months = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
    ];

    const scoreObj = scoresData?.[0] || {};
    const renderTable = (title, data) => {
        const getHeaderColor = () => {
            if (title.includes("Economic")) return "#a9560a";
            if (title.includes("Social")) return "#276712";
            if (title.includes("Governance")) return "#052A6B";
            return "#eee";
        };
        const getBodyColor = () => {
            if (title.includes("Economic")) return "rgb(229 218 206)";
            if (title.includes("Social")) return "rgb(214 255 217)";
            if (title.includes("Governance")) return "#cae0ff";
            return "#eee";
        };

        const headerColor = getHeaderColor();
        const bodyColor = getBodyColor();
        // const districtId = data?.[0]?.district_id;
        const isEconomic = title === "Economic";
        const isSocial = title === "Social";
        const isGovernance = title === "Governance";

        const economicCount = data?.filter((d) => d.cs_indicator_type === "Economic")?.length || 0;

        const subsectorGroups = {};
        for (let i = 0; i < (data?.length || 0); i++) {
            const name = data[i]?.ind_sub_sector_name || "";
            if (i === 0 || name !== (data[i - 1]?.ind_sub_sector_name || "")) {
                let j = i + 1;
                while (j < data.length && (data[j]?.ind_sub_sector_name || "") === name) j++;
                subsectorGroups[i] = j - i; // length of group starting at i
            }
        }

        const formatNum = (v) => {
            if (v === null || v === undefined) return "-";
            const n = Number(v);
            if (isNaN(n)) return "-";
            return n.toLocaleString("en-IN");
        };

        const formatZeroWhenAvgDash = (v, avg) => {
            const avgIsDash = avg === null || avg === undefined || String(avg) === "-" || String(avg) === "";
            if (v === null || v === undefined) return "-";
            const n = Number(v);
            if (isNaN(n)) return "-";
            if (n === 0 && avgIsDash) return "-";
            return n.toLocaleString("en-IN");
        };

        return (
            <div className="sectionCard" style={{ pageBreakInside: "auto", breakInside: "auto" }}>
                <table className="report-table econ-table">
                    <thead>
                        <tr>
                            <th className="custom-th-black th-no-wrap" style={{ background: headerColor, color: "#fff", border: "1px solid #d49a7a" }} > {" "} S.No{" "} </th>
                            <th className="custom-th-black" style={{ background: headerColor, color: "#fff", border: "1px solid #d49a7a", width: "20%", textAlign: "center", }} > {" "} Indicator{" "} </th>
                            <th className="custom-th-black th-no-wrap" style={{ background: headerColor, color: "#fff", border: "1px solid #d49a7a", width: "8%", }} > {" "} Unit{" "} </th>
                            {!isEconomic && (<th style={{ width: "6%", background: headerColor, color: "#fff", border: "1px solid #d49a7a" }}> Nature </th>)}
                            <th className="custom-th-black" style={{ background: headerColor, color: "#fff", border: "1px solid #d49a7a", textAlign: "center", }} > {" "}Period{" "} </th>
                            <th className="custom-th-black" style={{ background: headerColor, color: "#fff", border: "1px solid #d49a7a", width: "7%", textAlign: "center", }} > {" "} Annual Target (FY {selectedYear}){" "} </th>
                            <th className="custom-th-black th-achv th-wrap" style={{ background: headerColor, color: "#fff", border: "1px solid #d49a7a", width: "9%", textAlign: "center", }} > Proportionate Target​ </th>
                            <th className="custom-th-black th-bar" style={{ background: headerColor, color: "#fff", border: "1px solid #d49a7a", padding: "6px 10px", textAlign: "center", }} > {" "} Cumulative Achievement​{" "} </th>
                            {/* <th className="custom-th-black th-bar" style={{ background: headerColor, color: "#fff", border: "1px solid #d49a7a", padding: "6px 10px", textAlign: "center", }} > {" "} Growth over Previous Period(%) </th> */}
                            {isEconomic && (<th className="custom-th-black th-change th-wrap" style={{ background: headerColor, color: "#fff", border: "1px solid #d49a7a" }} > {" "} YTD Growth (%) {" "} </th>)}
                            <th className="custom-th-black th-no-wrap" style={{ background: headerColor, color: "#fff", border: "1px solid #d49a7a", textAlign: "center", }} > {" "} Score{" "} </th>
                            <th className="custom-th-black th-no-wrap" style={{ background: headerColor, color: "#fff", border: "1px solid #d49a7a", textAlign: "center", }} > {" "} Grade{" "} </th>
                            <th className="custom-th-black th-no-wrap" style={{ background: headerColor, color: "#fff", border: "1px solid #d49a7a", textAlign: "center", }} > {role === "2" || role === "64" ? "State Score" : "District Score"} </th>

                        </tr>
                    </thead>

                    <tbody>
                        {data.length > 0 ? (
                            data.map((item, i) => (
                                <React.Fragment key={i}>
                                    {item.sector && (i === 0 || data[i - 1]?.sector !== item.sector) && (
                                        <tr>
                                            <td
                                                colSpan={11}

                                                style={{ background: "#f7efe6", fontWeight: "bold", textAlign: "center", padding: "8px 12px", fontSize: "15px", }}
                                            >
                                                {" "}
                                                {item.sector}{" "}
                                            </td>
                                        </tr>
                                    )}

                                    <tr>
                                        <td>{i + 1}</td>
                                        <td style={{ textAlign: "left" }}>{item.cs_indicator_name ?? "-"}</td>
                                        <td>{item.unit ?? "-"}</td>
                                        {!isEconomic && <td> {item.indicator_nature || "-"} </td>}
                                        <td>{item.periodic_name ?? "-"}</td>
                                        <td style={{ textAlign: "right" }}> {(item.target ?? "-").toLocaleString("en-IN")} </td>
                                        <td style={{ textAlign: "right" }}> {formatZeroWhenAvgDash(item.current_cycle_target, item.averagescore)} </td>
                                        <td style={{ textAlign: "right" }}> {formatZeroWhenAvgDash(item.achivementvalue, item.averagescore)} </td>
                                        {/* <td>{item.cur_pre_growth ?? "-"}</td> */}
                                        {isEconomic && (
                                            <td style={{ textAlign: "right" }}>
                                                {Number(item?.ytd_growth_rate ?? "-") < 0 ? (
                                                    <span>
                                                        <span style={{ color: "#000" }}>{item.ytd_growth_rate ?? "-"}</span>{" "}
                                                        <span style={{ color: "red", marginLeft: "4px" }}> ▼ </span>{" "}
                                                    </span>
                                                ) : (
                                                    item?.ytd_growth_rate ?? "-"
                                                )}
                                            </td>
                                        )}

                                        <td className="td-no-wrap" style={{ textAlign: "right" }}> {" "} {item.averagescore === null ? "-" : item.averagescore ?? "-"}{" "} </td>
                                        <td className="td-no-wrap" style={{ textAlign: "right" }}> {" "} {item.grade ?? "-"}{" "} </td>
                                        <td className="td-no-wrap score-font" style={{ textAlign: "right", background: bodyColor, color: "#000", fontWeight: "700", }}> {" "} {item.state_district_score ?? "-"}{" "} </td>
                                    </tr>
                                </React.Fragment>
                            ))
                        ) : (
                            <tr>
                                {" "}
                                <td colSpan={isEconomic ? 9 : 8} style={{ textAlign: "center", padding: 10 }}>
                                    {" "}
                                    No Data{" "}
                                </td>{" "}
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        );
    };

    //     const getHeaderColor = () => {
    //         if (title.includes("Economic")) return "#f07d00";
    //         if (title.includes("Social")) return "#2e9e3a";
    //         if (title.includes("Governance")) return "#1f6fe0";
    //         return "#eee";
    //     };

    //     const headerColor = getHeaderColor();
    //     // const districtId = data?.[0]?.district_id;
    //     const isEconomic = title === "Economic";
    //     const isSocial = title === "Social";
    //     const isGovernance = title === "Governance";

    //     const economicCount = data?.filter((d) => d.cs_indicator_type === "Economic")?.length || 0;

    //     const subsectorGroups = {};
    //     for (let i = 0; i < (data?.length || 0); i++) {
    //         const name = data[i]?.ind_sub_sector_name || "";
    //         if (i === 0 || name !== (data[i - 1]?.ind_sub_sector_name || "")) {
    //             let j = i + 1;
    //             while (j < data.length && (data[j]?.ind_sub_sector_name || "") === name) j++;
    //             subsectorGroups[i] = j - i; // length of group starting at i
    //         }
    //     }

    //     return (
    //         <div className="sectionCard" style={{pageBreakInside: "auto", breakInside: "auto"}}>
    //             <table>
    //                 <thead>
    //                     <tr>
    //                         <th
    //                             className="custom-th-black th-no-wrap"
    //                             style={{background: headerColor, color: "#fff", border: "1px solid #d49a7a"}}
    //                         >
    //                             {" "}
    //                             S.No{" "}
    //                         </th>
    //                         <th
    //                             className="custom-th-black"
    //                             style={{
    //                                 background: headerColor,
    //                                 color: "#fff",
    //                                 border: "1px solid #d49a7a",
    //                                 width: "20%",
    //                                 textAlign: "center",
    //                             }}
    //                         >
    //                             {" "}
    //                             Indicator{" "}
    //                         </th>
    //                         <th
    //                             className="custom-th-black th-no-wrap"
    //                             style={{
    //                                 background: headerColor,
    //                                 color: "#fff",
    //                                 border: "1px solid #d49a7a",
    //                                 width: "8%",
    //                             }}
    //                         >
    //                             {" "}
    //                             Unit{" "}
    //                         </th>
    //                         <th
    //                             className="custom-th-black"
    //                             style={{
    //                                 background: headerColor,
    //                                 color: "#fff",
    //                                 border: "1px solid #d49a7a",
    //                                 textAlign: "center",
    //                             }}
    //                         >
    //                             {" "}
    //                             Reporting Period{" "}
    //                         </th>
    //                         <th
    //                             className="custom-th-black"
    //                             style={{
    //                                 background: headerColor,
    //                                 color: "#fff",
    //                                 border: "1px solid #d49a7a",
    //                                 width: "7%",
    //                                 textAlign: "center",
    //                             }}
    //                         >
    //                             {" "}
    //                             Annual Target (FY {selectedYear}){" "}
    //                         </th>
    //                         <th
    //                             className="custom-th-black th-achv th-wrap"
    //                             style={{
    //                                 background: headerColor,
    //                                 color: "#fff",
    //                                 border: "1px solid #d49a7a",
    //                                 width: "9%",
    //                                 textAlign: "center",
    //                             }}
    //                         >
    //                             Target For Reporting Period
    //                         </th>
    //                         <th
    //                             className="custom-th-black th-bar"
    //                             style={{
    //                                 background: headerColor,
    //                                 color: "#fff",
    //                                 border: "1px solid #d49a7a",
    //                                 padding: "6px 10px",
    //                                 textAlign: "center",
    //                             }}
    //                         >
    //                             {" "}
    //                             Achievement For Reporting Period{" "}
    //                         </th>
    //                         {/* <th
    //                             className="custom-th-black th-bar"
    //                             style={{
    //                                 background: headerColor,
    //                                 color: "#fff",
    //                                 border: "1px solid #d49a7a",
    //                                 padding: "6px 10px",
    //                                 textAlign: "center",
    //                             }}
    //                         >
    //                             {" "}
    //                             Growth over Previous Period(%)
    //                         </th> */}
    //                         <th
    //                             className="custom-th-black th-change th-wrap"
    //                             style={{background: headerColor, color: "#fff", border: "1px solid #d49a7a"}}
    //                         >
    //                             {" "}
    //                             YTD Growth (%){" "}
    //                         </th>
    //                         <th
    //                             className="custom-th-black th-no-wrap"
    //                             style={{
    //                                 background: headerColor,
    //                                 color: "#fff",
    //                                 border: "1px solid #d49a7a",
    //                                 textAlign: "center",
    //                             }}
    //                         >
    //                             {" "}
    //                             Score{" "}
    //                         </th>
    //                         <th
    //                             className="custom-th-black th-no-wrap"
    //                             style={{
    //                                 background: headerColor,
    //                                 color: "#fff",
    //                                 border: "1px solid #d49a7a",
    //                                 textAlign: "center",
    //                             }}
    //                         >
    //                             {" "}
    //                             Grade{" "}
    //                         </th>
    //                     </tr>
    //                 </thead>

    //                 <tbody>
    //                     {data.length > 0 ? (
    //                         data.map((item, i) => (
    //                             <React.Fragment key={i}>
    //                                 {item.sector && (i === 0 || data[i - 1]?.sector !== item.sector) && (
    //                                     <tr>
    //                                         <td
    //                                             colSpan={11}
    //                                             style={{
    //                                                 background: "#f7efe6",
    //                                                 fontWeight: "700",
    //                                                 textAlign: "left",
    //                                                 padding: "8px 12px",
    //                                                 border: "1px solid #d49a7a",
    //                                             }}
    //                                         >
    //                                             {" "}
    //                                             {item.sector}{" "}
    //                                         </td>
    //                                     </tr>
    //                                 )}

    //                                 <tr>
    //                                     <td>{i + 1}</td>
    //                                     <td style={{textAlign: "left"}}>{item.cs_indicator_name ?? "-"}</td>
    //                                     <td>{item.unit ?? "-"}</td>
    //                                     <td>{item.periodic_name ?? "-"}</td>
    //                                     <td style={{textAlign: "right"}}>
    //                                         {Number(item.target).toLocaleString("en-IN") ?? "-"}
    //                                     </td>
    //                                     <td style={{textAlign: "right"}}>
    //                                         {Number(item.current_cycle_target).toLocaleString("en-IN") ?? "-"}
    //                                     </td>
    //                                     <td style={{textAlign: "right"}}>
    //                                         {Number(item.achivementvalue || 0).toLocaleString("en-IN")}
    //                                     </td>

    //                                     {/* <td>{item.cur_pre_growth ?? "-"}</td> */}

    //                                     <td style={{textAlign: "right"}}>
    //                                         {Number(item?.ytd_growth_rate ?? "-") < 0 ? (
    //                                             <span>
    //                                                 <span style={{color: "#000"}}>{item.ytd_growth_rate ?? "-"}</span>{" "}
    //                                                 <span style={{color: "red", marginLeft: "4px"}}> ▼ </span>{" "}
    //                                             </span>
    //                                         ) : (
    //                                             item?.ytd_growth_rate ?? "-"
    //                                         )}
    //                                     </td>

    //                                     <td className="td-no-wrap" style={{textAlign: "right"}}>
    //                                         {" "}
    //                                         {item.averagescore === null ? "-" : item.averagescore ?? "-"}{" "}
    //                                     </td>
    //                                     <td className="td-no-wrap" style={{textAlign: "right"}}>
    //                                         {" "}
    //                                         {item.grade ?? "-"}{" "}
    //                                     </td>
    //                                 </tr>
    //                             </React.Fragment>
    //                         ))
    //                     ) : (
    //                         <tr>
    //                             {" "}
    //                             <td colSpan={isEconomic ? 9 : 8} style={{textAlign: "center", padding: 10}}>
    //                                 {" "}
    //                                 No Data{" "}
    //                             </td>{" "}
    //                         </tr>
    //                     )}
    //                 </tbody>
    //             </table>
    //         </div>
    //     );
    // };

    const getBarColor = (grade) => {
        if (grade === "A+") return "#9ED286";
        if (grade === "A") return "#FFCD1E";
        if (grade === "B") return "#3DD9FF";
        if (grade === "C") return "#FF6E74";
        return "#ccc";
    };

    const isEditable = (role === "64" ||  role === "73") && status !== "APPROVED";

    function ScoreRing({ value, color }) {
        const size = 96; const stroke = 9; const r = (size - stroke) / 2;
        const c = 2 * Math.PI * r; const offset = c - (value / 100) * c;
        return (
            <svg className="score-ring" width={size} height={size} viewBox={`0 0 ${size} ${size}`}>
                <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke="#e9edf1" strokeWidth={stroke} />
                <circle cx={size / 2} cy={size / 2} r={r}
                    fill="none" stroke={color} strokeWidth={stroke}
                    strokeLinecap="round" strokeDasharray={c}
                    strokeDashoffset={offset} transform={`rotate(-90 ${size / 2} ${size / 2})`} />
                <text x="50%" y="50%" dominantBaseline="central"
                    textAnchor="middle" className="score-ring-text" fill={color} >
                    {value} </text> </svg>);
    }

    function SemiGauge({ label, color }) {
        const pct = parseFloat(label) || 0;
        const w = 120; const h = 62; const r = 50; const cx = w / 2;
        const cy = h; const start = { x: cx - r, y: cy }; const end = { x: cx + r, y: cy };
        const clamped = Math.max(0, Math.min(100, pct)); const theta = Math.PI * (1 - clamped / 100);
        const px = cx + r * Math.cos(theta); const py = cy - r * Math.sin(theta); const large = clamped > 50 ? 1 : 0;
        return (
            <svg className="semi-gauge" width={w} height={h + 4} viewBox={`0 0 ${w} ${h + 4}`}>
                <path
                    d={`M ${start.x} ${start.y} A ${r} ${r} 0 0 1 ${end.x} ${end.y}`}
                    fill="none"
                    stroke="#e9edf1"
                    strokeWidth="9"
                    strokeLinecap="round"
                />
                <path
                    d={`M ${start.x} ${start.y} A ${r} ${r} 0  ${large} 1 ${px} ${py}`}
                    fill="none"
                    stroke={color}
                    strokeWidth="9"
                    strokeLinecap="round"
                />
                <text x={cx} y={cy - 6} textAnchor="middle" className="semi-gauge-text" fill="#1d2733">
                    {label}
                </text>
            </svg>
        );
    }

    function SummaryStrip({ summary, accent, gaugeColor }) {
        return (
            <div className="summary-strip">
                <div className="summary-block summary-basic">
                    <div className="sb-item">
                        <span className="sb-label"> Score</span>
                        <span className="sb-value" style={{ color: accent }}>
                            {summary.averageScore}
                        </span>
                    </div>
                    <div className="sb-item">
                        <span className="sb-label">Total Indicators</span>
                        <span className="sb-value" style={{ color: accent }}>
                            {summary.totalIndicators}
                        </span>
                    </div>

                    <div className="sb-item">
                        <span className="sb-label">Active Indicators</span>
                        <span className="sb-value" style={{ color: accent }}>
                            {summary.activeIndicators}
                        </span>
                    </div>
                    <div className="sb-item">
                        <span className="sb-label">Inactive Indicators</span>
                        <span className="sb-value" style={{ color: accent }}>
                            {summary.inactiveIndicators}
                        </span>
                    </div>
                </div>

                <div className="summary-block summary-targets">
                    <div className="st-item">
                        <span className="st-label">Achiever</span>
                        <span className="st-value" style={{ color: "#1f8a34" }}>
                            {summary.onTarget.value}
                        </span>
                        {/* <MiniBar pct={summary.onTarget.pct} color="#1f8a34" /> */}
                        <span className="st-pct">A+ Grade</span>
                    </div>
                    <div className="st-item">
                        <span className="st-label">Front Runner</span>
                        <span className="st-value" style={{ color: "#1f8a34" }}>
                            {summary.aboveTarget.value}
                        </span>
                        <span className="st-pct">A Grade</span>
                    </div>
                    <div className="st-item">
                        <span className="st-label">Performer</span>
                        <span className="st-value" style={{ color: "#f07d00" }}>
                            {summary.belowTarget.value}
                        </span>
                        <span className="st-pct">B Grade</span>
                    </div>
                    <div className="st-item">
                        <span className="st-label">Aspirant</span>
                        <span className="st-value" style={{ color: "#e03131" }}>
                            {summary.belowTarget.value}
                        </span>
                        <span className="st-pct">C Grade</span>
                    </div>
                </div>

                <div className="summary-block summary-gauge">
                    <span className="sg-label">Average Achievements</span>
                    <SemiGauge label={summary.averageAchievements} color={gaugeColor} />
                </div>
            </div>
        );
    }

    return (
        <>
            <Menubar />
            <div
                style={{
                    background: "#f4f6f9",
                    padding: "25px 0 60px 0",
                    minHeight: "70vh",
                    display: "flex",
                    justifyContent: "center",
                }}
            >
                <div style={{ width: "100%", maxWidth: "90%" }}>
                    <div className="row g-2 align-items-end mb-3">
                        <div className="col-6 col-md-2">
                            <label className="form-label toolbar-label">
                                Score-Cat <span className="text-danger">*</span>
                            </label>
                            <select
                                className="form-select form-select-sm"
                                name="category"
                                value={formik.values.category}
                                onChange={(e) => {
                                    formik.setFieldValue("category", e.target.value);
                                    setScoresData([]);
                                    setCriteriaData([]);
                                    setIndicatorData([]);
                                    setRemarks("");
                                    setStatus("");
                                    formik.setFieldValue("year", "");
                                    formik.setFieldValue("month", "");
                                }}
                            >
                                {categoryOptions.map((opt) => (
                                    <option key={opt.value} value={opt.value}>
                                        {" "}
                                        {opt.label}{" "}
                                    </option>
                                ))}
                            </select>
                        </div>
                        <div className="col-6 col-md-2">
                            <label className="form-label toolbar-label">Year</label>
                            <select
                                className="form-select form-select-sm"
                                name="year"
                                value={formik.values.year}
                                onChange={(e) => {
                                    formik.setFieldValue("year", e.target.value);
                                    formik.setFieldValue("month", "");
                                }}
                            >
                                <option value="">--select--</option> <option value="2025-26">2025-26</option>{" "}
                                <option value="2026-27">2026-27</option>{" "}
                            </select>
                        </div>

                        <div
                            className="col-6 col-md-2"
                            style={{ visibility: formik.values.category === "month" ? "visible" : "hidden" }}
                        >
                            <label className="form-label toolbar-label">Month</label>
                            <select
                                className="form-select form-select-sm"
                                name="month"
                                value={formik.values.month}
                                onChange={(e) => {
                                    formik.setFieldValue("month", e.target.value);
                                    formik.handleSubmit();
                                }}
                            >
                                <option value="">--select--</option>
                                {monthOptions.map((opt) => (
                                    <option key={opt.value} value={opt.value}>
                                        {opt.label}
                                    </option>
                                ))}
                            </select>
                        </div>

                        {statusCode === "1" ||
                            (scoresData?.length > 0 && (
                                <div className="col-12 col-md-6">
                                    <div className="toolbar-actions">
                                        <div className="search-wrap">
                                            <input
                                                type="text"
                                                className="form-control form-control-sm"
                                                placeholder="Search Indicators"
                                                value={searchIndicatorData}
                                                onChange={(e) => setSearchIndicatorData(e.target.value)}
                                            />
                                            <span className="search-icon">&#128269;</span>
                                        </div>
                                        <OverlayTrigger
                                            trigger={["hover", "focus", "click"]}
                                            placement="top"
                                            overlay={<Tooltip id="download-tooltip">Download PDF</Tooltip>}
                                        >
                                            <button
                                                type="button"
                                                className="btn btn-sm btn-outline-secondary btn-export"
                                                onClick={handlePrint}
                                                disabled={isDownloading}
                                            >
                                                {isDownloading ? (
                                                    <span className="spinner-border spinner-border-sm"></span>
                                                ) : (
                                                    <span className="ico-pdf">&#128196;</span>
                                                )}{" "}
                                                Export PDF
                                            </button>
                                        </OverlayTrigger>
                                        {generatedTime && <div className="toolbar-stamp mb-2">{generatedTime}</div>}
                                    </div>
                                </div>
                            ))}
                    </div>

                    {statusCode === "1" ||
                        (scoresData?.length > 0 && (
                            <div ref={reportRef} id="report-container">
                                <div
                                    className="top-grid"
                                    style={{
                                        gridTemplateColumns: "1.35fr 4fr",
                                        gap: "5px",
                                        alignItems: "stretch",
                                        marginBottom: "16px",
                                    }}
                                >
                                    {/* =====================================================
      LEFT : DISTRICT / MANDAL / CONSTITUENCY
  ====================================================== */}
                                    <div
                                        className="district-card"
                                        style={{
                                            gridColumn: "1",
                                            gridRow: "1",
                                            alignSelf: "stretch",
                                            height: "auto",
                                            minHeight: "100%",
                                            boxSizing: "border-box",
                                        }}
                                    >
                                        <img src="../images/dc-bg.png" className="dc-bg" />
                                        <div className="dc-info">
                                            <div className="dc-sub">
                                                {role === "2" || role === "64"
                                                    ? "District"
                                                    : role === "65" || role === "73"
                                                        ? "Constituency"
                                                        : "Mandal"}{" "}
                                                {scoreCatId} Report
                                            </div>

                                            <div className="dc-title">
                                                {role === "2" || role === "64"
                                                    ? scoreObj?.district_name || ""
                                                    : role === "65" || role === "73"
                                                        ? scoreObj?.acname || ""
                                                        : scoreObj?.mandal_name || ""}
                                            </div>

                                            <div className="dc-period">
                                                ({months[scoreObj?.score_for_month - 1]} {selectedYear})
                                            </div>
                                        </div>
                                    </div>

                                    {/* =====================================================
      RIGHT SIDE : LEGEND + SCORE CARDS
  ====================================================== */}
                                    <div
                                        style={{
                                            gridColumn: "2",
                                            gridRow: "1",
                                            display: "flex",
                                            flexDirection: "column",
                                            gap: "10px",
                                            minWidth: 0,
                                            alignSelf: "stretch",
                                        }}
                                    >
                                        {/* =================================================
        SCORE CARDS
    ================================================== */}
                                        <div
                                            style={{
                                                display: "grid",
                                                gridTemplateColumns: "repeat(4, minmax(0, 1fr))",
                                                gap: "16px",
                                                minWidth: 0,
                                                alignItems: "stretch",
                                                flex: 1,
                                            }}
                                        >
                                            {/* ================= OVERALL ================= */}
                                            <div
                                                className="score-card"
                                                style={{
                                                    height: "auto",
                                                    minHeight: 0,
                                                    boxSizing: "border-box",
                                                }}
                                            >
                                                <div className="score-label" style={{ color: getBarColor(scoreObj?.grade) }}>
                                                    OVERALL SCORE
                                                </div>

                                                <ScoreRing
                                                    value={scoreObj?.averagescore || "-"}
                                                    color={scoreObj?.color_code}
                                                />

                                                <div className="score-grade-row">
                                                    <span className="score-grade-label">Grade</span>

                                                    <span
                                                        className="score-grade-badge"
                                                        style={{
                                                            backgroundColor: getBarColor(scoreObj?.grade),
                                                        }}
                                                    >
                                                        {scoreObj?.grade || "-"}
                                                    </span>
                                                </div>
                                            </div>

                                            {/* ================= ECONOMIC ================= */}
                                            <div
                                                className="score-card"
                                                style={{
                                                    height: "auto",
                                                    minHeight: 0,
                                                    boxSizing: "border-box",
                                                }}
                                            >
                                                <div className="score-label" style={{ color: getBarColor(economicData?.grade) }}>
                                                    ECONOMIC
                                                </div>

                                                <ScoreRing
                                                    value={economicData?.averagescore || "-"}
                                                    color={economicData?.color_code}
                                                />

                                                <div className="score-grade-row">
                                                    <span className="score-grade-label">Grade</span>

                                                    <span
                                                        className="score-grade-badge"
                                                        style={{
                                                            backgroundColor: getBarColor(economicData?.grade),
                                                        }}
                                                    >
                                                        {economicData?.grade || "-"}
                                                    </span>
                                                </div>
                                            </div>

                                            {/* ================= SOCIAL ================= */}
                                            <div
                                                className="score-card"
                                                style={{
                                                    height: "auto",
                                                    minHeight: 0,
                                                    boxSizing: "border-box",
                                                }}
                                            >
                                                <div className="score-label" style={{ color: getBarColor(socialData?.grade) }}>
                                                    SOCIAL
                                                </div>

                                                <ScoreRing
                                                    value={socialData?.averagescore || "-"}
                                                    color={socialData?.color_code}
                                                />

                                                <div className="score-grade-row">
                                                    <span className="score-grade-label">Grade</span>

                                                    <span
                                                        className="score-grade-badge"
                                                        style={{
                                                            backgroundColor: getBarColor(socialData?.grade),
                                                        }}
                                                    >
                                                        {socialData?.grade || "-"}
                                                    </span>
                                                </div>
                                            </div>

                                            {/* ================= GOVERNANCE ================= */}
                                            <div
                                                className="score-card"
                                                style={{
                                                    height: "auto",
                                                    minHeight: 0,
                                                    boxSizing: "border-box",
                                                }}
                                            >
                                                <div className="score-label" style={{ color: getBarColor(governanceData?.grade) }}>
                                                    GOVERNANCE
                                                </div>

                                                <ScoreRing
                                                    value={governanceData?.averagescore || "-"}
                                                    color={governanceData?.color_code}
                                                />

                                                <div className="score-grade-row">
                                                    <span className="score-grade-label">Grade</span>

                                                    <span
                                                        className="score-grade-badge"
                                                        style={{
                                                            backgroundColor: getBarColor(governanceData?.grade),
                                                        }}
                                                    >
                                                        {governanceData?.grade || "-"}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>

                                        {/*=============== GRADE LEGEND =============== */}
                                        <div style={{
                                            backgroundColor: "#fff", border: "1px solid var(--line)",
                                            borderRadius: "10px", padding: "6px 10px", boxSizing: "border-box",
                                            display: "flex", alignItems: "center", justifyContent: "center",
                                            gap: "18px", width: "calc(100% - 2px)", maxWidth: "calc(100% - 2px)",
                                            overflow: "hidden",
                                        }} >
                                            {[
                                                { color: "#ff5a5a", text: "Aspirant (C) <50%", },
                                                { color: "#2fb4ff", text: "Performer (B) 50%-74%", },
                                                { color: "#f7c600", text: "Front Runner (A) 75%-89%", },
                                                { color: "#6cc04a", text: "Achiever (A+) 90%-100%", },
                                            ].map((item) => (
                                                <div
                                                    key={item.text}
                                                    style={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        gap: "5px",
                                                        whiteSpace: "nowrap",
                                                        flexShrink: 1,
                                                        minWidth: 0,
                                                    }}
                                                >
                                                    <span
                                                        style={{
                                                            width: "11px",
                                                            height: "11px",
                                                            minWidth: "11px",
                                                            borderRadius: "50%",
                                                            backgroundColor: item.color,
                                                            display: "inline-block",
                                                            flexShrink: 0,
                                                        }}
                                                    />

                                                    <span
                                                        style={{
                                                            fontSize: "11px",
                                                            fontWeight: 600,
                                                            whiteSpace: "nowrap",
                                                        }}
                                                    >
                                                        {item.text}
                                                    </span>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>

                                <section className="report-section section-economic" style={{ marginTop: 20 }}>
                                    <div className="section-head">
                                        <div className="section-head-title">
                                            {/* <span className="section-icon">&#128200;</span> */}
                                            <span className="section-icon">
                                                <img src="../../images/print-economic.svg" width={30} />
                                            </span>
                                            <div>
                                                <div className="sh-name">ECONOMIC</div>
                                                <div className="sh-desc"> Driving Growth</div>
                                            </div>
                                        </div>
                                        <SummaryStrip
                                            summary={{
                                                totalIndicators: economicTable?.length,
                                                averageScore: economicData?.averagescore,
                                                highestScore: Math.max(
                                                    ...economicTable.map((item) =>
                                                        isNaN(item?.averagescore) ? 0 : item?.averagescore
                                                    )
                                                ).toFixed(2),
                                                lowestScore: Math.min(
                                                    ...economicTable.map((item) =>
                                                        isNaN(item?.averagescore) ? 0 : item?.averagescore
                                                    )
                                                ).toFixed(2),
                                                activeIndicators: economicTable.filter(
                                                    (item) =>
                                                        item?.averagescore != null &&
                                                        item?.averagescore !== "" &&
                                                        !isNaN(Number(item?.averagescore))
                                                ).length,
                                                inactiveIndicators:
                                                    (economicTable?.length || 0) -
                                                    economicTable.filter(
                                                        (item) =>
                                                            item?.averagescore != null &&
                                                            item?.averagescore !== "" &&
                                                            !isNaN(Number(item?.averagescore))
                                                    ).length,
                                                onTarget: {
                                                    value: economicTable.filter((item) => item.grade === "A+").length,
                                                },
                                                aboveTarget: {
                                                    value: economicTable.filter((item) => item.grade === "A").length,
                                                },
                                                belowTarget: {
                                                    value: economicTable.filter((item) => item.grade === "B").length,
                                                },
                                                aspTarget: {
                                                    value: economicTable.filter((item) => item.grade === "C").length,
                                                },
                                                averageAchievements: "100%",
                                                // averageAchievements: "82.96%",
                                            }}
                                            accent="#f07d00"
                                            gaugeColor="#f07d00"
                                        />
                                    </div>
                                    <div className="dashboardtable-wrap">{renderTable("Economic", economicTable)}</div>
                                </section>
                                <section className="report-section section-social">
                                    <div className="section-head">
                                        <div className="section-head-title">
                                            {/* <span className="section-icon">&#128101;</span> */}
                                            <span className="section-icon">
                                                <img src="../../images/print-social.svg" width={30} />
                                            </span>
                                            <div>
                                                <div className="sh-name">SOCIAL</div>
                                                <div className="sh-desc"> Improving Quality of Life</div>
                                            </div>
                                        </div>
                                        <SummaryStrip
                                            summary={{
                                                totalIndicators: socialTable?.length,
                                                averageScore: socialData?.averagescore,
                                                highestScore: Math.max(
                                                    ...socialTable.map((item) =>
                                                        isNaN(item?.averagescore) ? 0 : item?.averagescore
                                                    )
                                                ).toFixed(2),
                                                lowestScore: Math.min(
                                                    ...socialTable.map((item) =>
                                                        isNaN(item?.averagescore) ? 0 : item?.averagescore
                                                    )
                                                ).toFixed(2),
                                                activeIndicators: socialTable.filter(
                                                    (item) =>
                                                        item?.averagescore != null &&
                                                        item?.averagescore !== "" &&
                                                        !isNaN(Number(item?.averagescore))
                                                ).length,
                                                inactiveIndicators:
                                                    (socialTable?.length || 0) -
                                                    socialTable.filter(
                                                        (item) =>
                                                            item?.averagescore != null &&
                                                            item?.averagescore !== "" &&
                                                            !isNaN(Number(item?.averagescore))
                                                    ).length,
                                                onTarget: {
                                                    value: socialTable.filter((item) => item.grade === "A+").length,
                                                },
                                                aboveTarget: {
                                                    value: socialTable.filter((item) => item.grade === "A").length,
                                                    pct: "22.22%",
                                                },
                                                belowTarget: {
                                                    value: socialTable.filter((item) => item.grade === "B").length,
                                                    pct: "0%",
                                                },
                                                aspTarget: {
                                                    value: socialTable.filter((item) => item.grade === "C").length,
                                                    pct: "0%",
                                                },
                                                averageAchievements: "100%",
                                                // averageAchievements: "82.96%",
                                            }}
                                            accent="#2e9e3a"
                                            gaugeColor="#2e9e3a"
                                        />
                                    </div>
                                    <div className="dashboardtable-wrap">{renderTable("Social", socialTable)}</div>
                                </section>
                                <section className="report-section section-governance">
                                    <div className="section-head">
                                        <div className="section-head-title">
                                            {/* <span className="section-icon">&#127963;</span> */}
                                            <span className="section-icon">
                                                <img src="../../images/print-governance.svg" width={30} />
                                            </span>
                                            <div>
                                                <div className="sh-name">GOVERNANCE</div>
                                                <div className="sh-desc"> Strengthening Service Delivery </div>
                                            </div>
                                        </div>
                                        <SummaryStrip
                                            summary={{
                                                totalIndicators: governanceTable?.length,
                                                averageScore: governanceData?.averagescore,
                                                highestScore: Math.max(
                                                    ...governanceTable.map((item) =>
                                                        isNaN(item?.averagescore) ? 0 : item?.averagescore
                                                    )
                                                ).toFixed(2),
                                                lowestScore: Math.min(
                                                    ...governanceTable.map((item) =>
                                                        isNaN(item?.averagescore) ? 0 : item?.averagescore
                                                    )
                                                ).toFixed(2),
                                                activeIndicators: governanceTable.filter(
                                                    (item) =>
                                                        item?.averagescore != null &&
                                                        item?.averagescore !== "" &&
                                                        !isNaN(Number(item?.averagescore))
                                                ).length,
                                                inactiveIndicators:
                                                    (governanceTable?.length || 0) -
                                                    governanceTable.filter(
                                                        (item) =>
                                                            item?.averagescore != null &&
                                                            item?.averagescore !== "" &&
                                                            !isNaN(Number(item?.averagescore))
                                                    ).length,
                                                onTarget: {
                                                    value: governanceTable.filter((item) => item.grade === "A+").length,
                                                },
                                                aboveTarget: {
                                                    value: governanceTable.filter((item) => item.grade === "A").length,
                                                },
                                                belowTarget: {
                                                    value: governanceTable.filter((item) => item.grade === "B").length,
                                                },
                                                aspTarget: {
                                                    value: governanceTable.filter((item) => item.grade === "C").length,
                                                },
                                                averageAchievements: "100%",
                                            }}
                                            accent="#1f6fe0"
                                            gaugeColor="#1f6fe0"
                                        />
                                    </div>
                                    <div className="dashboardtable-wrap">{renderTable("Governance", governanceTable)}</div>
                                </section>

                                {role !== "65" && role !== "73" && barData.length > 0 && (
                                    <div style={{ width: "100%", height: "500px", border: "1px solid #ccc", background: "#fff", overflowY: "auto", }} >
                                        <ResponsiveContainer width="90%" height="100%">
                                            <BarChart
                                                data={barData}
                                                layout="vertical"
                                                margin={{
                                                    top: 20,
                                                    left: 0,
                                                    bottom: 10,
                                                    right: 10
                                                }}
                                                barCategoryGap="25%"
                                            >
                                                <XAxis
                                                    type="number"
                                                    domain={[0, 100]}
                                                    allowDataOverflow={false}
                                                    tick={{ fontSize: 8, fontWeight: "bold", fill: "#000", }}
                                                    label={{
                                                        value: `Score (${months[scoreObj?.score_for_month - 1]} ${selectedYear})`,
                                                        position: "insideBottom",
                                                        fill: "#000",
                                                        fontSize: 11
                                                    }}
                                                />

                                                <YAxis
                                                    type="category"
                                                    dataKey={
                                                        role === "2" || role === "64"
                                                            ? "district_name"
                                                            : "mandal_name"
                                                    }
                                                    width={200}
                                                    interval={0}
                                                    tick={({ x, y, payload }) => {
                                                        const entry = barData.find((item) =>
                                                            role === "2" || role === "64"
                                                                ? String(item.district_id) === String(districtid) &&
                                                                item.district_name === payload.value
                                                                : String(item.mandal_id) === String(mandalid) &&
                                                                item.mandal_name === payload.value
                                                        );

                                                        return (
                                                            <text
                                                                x={x - 5}
                                                                y={y}
                                                                textAnchor="end"
                                                                dominantBaseline="middle"
                                                                fontSize={10}
                                                                fill={entry ? getBarColor(entry.grade) : "#000"}
                                                            >
                                                                {payload.value}
                                                            </text>
                                                        );
                                                    }}
                                                />

                                                <Tooltip
                                                    formatter={(value) => [
                                                        Number(value),
                                                        "Score",
                                                    ]}
                                                    labelFormatter={(label) =>
                                                        role === "65" || role === "73"
                                                            ? `Constituency: ${label}`
                                                            : `District: ${label}`
                                                    }
                                                />

                                                <Bar
                                                    dataKey="average_score"
                                                    name="Average Score"
                                                    barSize={10}
                                                >
                                                    {barData.map((entry, index) => (


                                                        <Cell
                                                            key={`cell-${index}`} fill={getBarColor(entry.grade)} />
                                                    ))}

                                                    <LabelList
                                                        dataKey="average_score"
                                                        position="right"
                                                        fill="#000"
                                                        fontSize={10}
                                                        formatter={(value) => Number(value).toFixed(0)}
                                                    />
                                                </Bar>
                                            </BarChart>
                                        </ResponsiveContainer>
                                    </div>
                                )}

                                <div style={{ marginTop: 15 }}>
                                    <div
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            gap: "8px",
                                            fontWeight: 700,
                                            fontSize: "18px",
                                            marginBottom: 10,
                                        }}
                                    >
                                        {" "}
                                        <span style={{ fontSize: "20px" }}>📝</span> Remarks:{" "}
                                    </div>

                                    <textarea
                                        value={remarks || ""}
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            if (value.length <= 1000) setRemarks(value);
                                            if (value.length === 1000) {
                                                showAlertMessage("Maximum 1000 characters allowed", "warning");
                                            }
                                        }}
                                        maxLength={1000}
                                        placeholder="Enter remarks here..."
                                        disabled={
                                            ((role === "64" || role === "73") && isRemarksEmpty) ||
                                            ((role === "64" ||  role === "73") &&
                                                status === "APPROVED") ||
                                            ((role === "2" || role === "3" || role === "65") &&
                                                status === "FORWARDED") ||
                                            ((role === "2" || role === "3" || role === "65") && status === "APPROVED")
                                        }
                                        style={{
                                            width: "100%",
                                            minHeight: 100,
                                            padding: 12,
                                            border: "2px solid #999",
                                            borderRadius: 4,
                                            resize: "vertical",
                                            fontFamily: "inherit",
                                            backgroundColor:
                                                ((role === "64" ||  role === "73") && isRemarksEmpty) ||
                                                    ((role === "2" || role === "3") && status === "FORWARDED")
                                                    ? "#f5f5f5"
                                                    : "#fff",
                                            cursor:
                                                ((role === "64" ||  role === "73") && isRemarksEmpty) ||
                                                    ((role === "2" || role === "3") && status === "FORWARDED")
                                                    ? "not-allowed"
                                                    : "text",
                                        }}
                                    />
                                </div>
                                {descTime && (
                                    <Alert className="py-2 px-3 mb-2" style={{ fontSize: "12px", backgroundColor: "#fdecec", borderColor: "#f5b5b5", color: "#a00000", }} >
                                        <strong>Disclaimer:</strong> This report was generated based on the data
                                        available in the portal on <strong>{descTime}</strong>.
                                    </Alert>
                                )}
                                {isLocked ? (
                                    <div
                                        className="no-print"
                                        style={{ marginTop: 24, display: "flex", justifyContent: "center" }}
                                    >
                                        <Button
                                            variant="primary"
                                            onClick={handlePrint}
                                            disabled={isDownloading}
                                        >
                                            {isDownloading ? (
                                                <span className="spinner-border spinner-border-sm"></span>
                                            ) : (
                                                "📄 Print"
                                            )}
                                        </Button>
                                    </div>
                                ) : (
                                    <div
                                        className="no-print"
                                        style={{ marginTop: 24, display: "flex", justifyContent: "center" }}
                                    >
                                        <Button variant="success" onClick={isEditable ? handleApprove : SaveandForward}>
                                            <IoSendOutline size={18} />
                                            {role === "2" || role === "3" || role === "65"
                                                ? "Send to Next Level"
                                                : "Approve"}
                                        </Button>
                                    </div>
                                )}
                            </div>
                        ))}
                </div>
            </div>

            <AlertModal
                show={showAlert}
                titleText={alertData.titleText}
                alertText={alertData.alertText}
                onClose={closeAlert}
            />
        </>
    );
};

export default CriteriaPerformance;
